import { render, staticRenderFns } from "./notification-DocumentMention.vue?vue&type=template&id=35832a5a&scoped=true"
import script from "./notification-DocumentMention.vue?vue&type=script&lang=js"
export * from "./notification-DocumentMention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35832a5a",
  null
  
)

export default component.exports